import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';
//import { MsalService } from '../services/msal.service';
import { Observable } from 'rxjs';

/**
 * This pipe is used to insert the header in the link that makes an API call to the server to receive the thumbnail image
 */

@Pipe({
    name: 'authImage',
    standalone: false
})

export class AuthImagePipe implements PipeTransform {

  constructor(
      private http: HttpClient,
      //private msalService: MsalService
  ) {}

  async transform(src: string): Promise<string> {

    if (!src) { return; }
      const token = this.GetAccessToken(); //this.msalService.GetAccessToken();
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });

    try {
      const imageBlob = await this.http.get(src, {headers, responseType: 'blob'}).toPromise();
      const reader = new FileReader();

      return new Promise((resolve) => {
        reader.onloadend = () => resolve(reader.result as string);
        reader.readAsDataURL(imageBlob);
      });
    } catch (error) {
      //console.error('error', error);
      return; //default image
    }
  }

    
  private GetAccessToken(): Observable < any > {
 let accessToken: any;
    if (sessionStorage.getItem('msal.idtoken') !== undefined && sessionStorage.getItem('msal.idtoken') != null) {
          accessToken = sessionStorage.getItem('msal.idtoken');
        }
    return accessToken;
  }
}
